const generalLocaleCache = {};
const routeLocaleCache = {};
const dynamicTranslationsCaches = [];
const serverTranslationCache = {};
const serverTranslationInit = {};
function deepClone(value) {
  if (Array.isArray(value)) {
    return JSON.parse(JSON.stringify(value));
  } else if (typeof value === "object" && value !== null) {
    return JSON.parse(JSON.stringify(value));
  }
  return value;
}
function findTranslation(translations, parts) {
  let value = translations;
  for (const part of parts) {
    if (value && typeof value === "object" && part in value) {
      value = value[part];
    } else {
      return null;
    }
  }
  if (typeof value === "object" && value !== null) {
    return deepClone(value);
  }
  return value ?? null;
}
export function useTranslationHelper() {
  return {
    hasCache(locale, page) {
      return (serverTranslationCache[`${locale}:${page}`] ?? /* @__PURE__ */ new Map()).size > 0;
    },
    getCache(locale, routeName) {
      return serverTranslationCache[`${locale}:${routeName}`];
    },
    setCache(locale, routeName, cache) {
      const cacheKey = `${locale}:${routeName}`;
      serverTranslationCache[`${locale}:${routeName}`] = cache;
      serverTranslationInit[`${locale}:index`] = true;
      serverTranslationInit[cacheKey] = true;
    },
    mergeTranslation(locale, routeName, newTranslations, force = false) {
      if (!force && !routeLocaleCache[`${locale}:${routeName}`]) {
        console.error(`marge: route ${locale}:${routeName} not loaded`);
      }
      routeLocaleCache[`${locale}:${routeName}`] = {
        ...routeLocaleCache[`${locale}:${routeName}`],
        ...newTranslations
      };
    },
    mergeGlobalTranslation(locale, newTranslations, force = false) {
      if (!force && !generalLocaleCache[`${locale}`]) {
        console.error(`marge: route ${locale} not loaded`);
      }
      generalLocaleCache[locale] = {
        ...generalLocaleCache[locale],
        ...newTranslations
      };
    },
    hasGeneralTranslation(locale) {
      return !!generalLocaleCache[locale];
    },
    hasPageTranslation(locale, routeName) {
      return !!routeLocaleCache[`${locale}:${routeName}`];
    },
    getTranslation: (locale, routeName, key) => {
      const cacheKey = `${locale}:${routeName}`;
      const cached = serverTranslationCache[cacheKey]?.get(key);
      if (cached) {
        return cached;
      }
      const parts = key.split(".");
      let result = null;
      for (const dynamicCache of dynamicTranslationsCaches) {
        result = findTranslation(dynamicCache[locale] || null, parts);
        if (result !== null) break;
      }
      if (!result) {
        result = findTranslation(routeLocaleCache[cacheKey] || null, parts) ?? findTranslation(generalLocaleCache[locale] || null, parts);
      }
      if (result) {
        if (!serverTranslationCache[cacheKey]) {
          serverTranslationCache[cacheKey] = /* @__PURE__ */ new Map();
        }
        serverTranslationCache[cacheKey].set(key, result);
      }
      return result;
    },
    async loadPageTranslations(locale, routeName, translations) {
      const cacheKey = `${locale}:${routeName}`;
      routeLocaleCache[cacheKey] = { ...translations };
      serverTranslationInit[cacheKey] = true;
    },
    async loadTranslations(locale, translations) {
      generalLocaleCache[locale] = { ...translations };
      serverTranslationInit[`${locale}:index`] = true;
    }
  };
}
